module.exports = __webpack_public_path__ + "static/media/icon.f4df9852.svg";